// extracted by mini-css-extract-plugin
export default {"root":"AddVTab_root__aBzJC","add-icon":"AddVTab_add-icon__fGYrL"};